// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"ecc345ef","787":"cc769e2d","795":"3ca693b9","966":"3e5fa7fb","984":"a7a3f057"}[chunkId] + ".chunk.js";
};